import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'product-carousel',
                label: 'Carrosséis',
                routerLink: ['/extensions/product-carousels'],
                icon: 'image-gallery',
                requiresPermission: (userPermissions) =>
                    userPermissions.includes('ReadProductCarousel'),
            },
            'marketing'
        ),
    ],
})
export class ProductCarouselNavModule {}
